import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ConfigurationService } from './configuration.service';
import { AuthService } from './auth.service';

export interface CourseProgress {
  completedActivities: number;
  percentage: number;
  isComplete: boolean;
  lastUpdated: Date;
}

@Injectable({
  providedIn: 'root'
})
export class CourseProgressService {

  private progressSubject = new BehaviorSubject<CourseProgress>({
    completedActivities: 0,
    percentage: 0,
    isComplete: false,
    lastUpdated: new Date()
  });

  public progress$ = this.progressSubject.asObservable();

  constructor(
    private configurationService: ConfigurationService,
    private authService: AuthService
  ) {
    this.initializeProgress();
  }

  private initializeProgress(): void {
    const savedPercentage = localStorage.getItem('percentage');
    if (savedPercentage) {
      const percentage = parseInt(savedPercentage, 10);
      const completedActivities = Math.round((percentage * this.configurationService.totalActivities) / 100);
      this.updateProgress(completedActivities);
    }
  }

  updateProgress(completedActivities: number): void {
    const percentage = this.configurationService.calculateProgress(completedActivities);
    const isComplete = this.configurationService.isCourseComplete(completedActivities);

    const progress: CourseProgress = {
      completedActivities,
      percentage,
      isComplete,
      lastUpdated: new Date()
    };

    this.progressSubject.next(progress);
    localStorage.setItem('percentage', percentage.toString());

    if (isComplete && this.authService.getCourseCompleted() === 'false') {
      this.authService.setCourseCompleted();
    }
  }

  getCurrentProgress(): CourseProgress {
    return this.progressSubject.value;
  }

  isClassAccessible(classNumber: number): boolean {
    const progress = this.getCurrentProgress();
    const requiredActivities = (classNumber - 1) * this.configurationService.activitiesPerClass;
    return progress.completedActivities >= requiredActivities;
  }

}
